import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit,ChangeDetectorRef } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ColDef, ExcelExportParams, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';
import { IDropdownSettings } from "ng-multiselect-dropdown";

import { Config } from 'src/app/app-constant';
import { formatText } from 'src/app/shared/commen-function-file';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { ToastrService } from 'ngx-toastr';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';
interface AssetNode {
  id: any;
  assetName: string;
  children?: AssetNode[];
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-user-asset',
  templateUrl: './user-asset.component.html',
  styleUrls: ['./user-asset.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})


export class UserAssetComponent implements OnInit {
  buttonColorName: any;
  updateData: any;
  userListDataForAsset: any;
  dropdownSettingsForBand: IDropdownSettings = {};
  dropdownSettingsForAsset: IDropdownSettings = {};
  dropdownSettingsForEmployee: IDropdownSettings = {};
  selectedEmployeeIdForReport: any;
  dropdownDataForAsset: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  oprationMethod: any;
  todayDate: any;
  formatedataVariable = formatText;
  datedisplay: any
  searchTaskString: string = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private encryptionService: EncryptionService, public dialog: MatDialog, private toastr: ToastrService,
    private config: Config, private httpService: HttpService, private datePipe: DatePipe, public dialogRef: MatDialogRef<UserAssetComponent>,private cdRef: ChangeDetectorRef) {
    console.log(data);

    this.todayDate = new Date().toISOString().split('T')[0];
    this.datedisplay = this.todayDate
    this.oprationMethod = data.operation
    this.year = data?.year;
    this.fiscalYear = data?.fiscal_year;
    this.updateData = data?.data;
    console.log("this.updateData", this.updateData);
    if (this.updateData != null) {
      this.selectedAsset = this.updateData.users.map((elm: any) => elm.assetId);
      this.selectedAsset = this.selectedAsset[0];

      this.onAssetChange(this.selectedAsset);

    }

  }



  assetOptions: string[] = [
    'ASSET_GIVEN',
    'ASSET_REPAIRED',
    'RECEIVED_AFTER_EXIT',
    'NOT_RECEIVED_AFTER_EXIT',
    'IN_PROGRESS',
    'OTHER_REASON'
  ];

 
  ngOnInit() {
    this.buildColumnDefs();
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');

    this.loggedInUserId = sessionStorage.getItem('loggedInUserRole');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getAllaseetListingData();
    this.assetAllocationData();


    // this.allAssets = this.userListDataForAsset.users.map((asset: { assetName: any; }) => asset.assetName);

    this.dropdownSettingsForBand = {
      singleSelection: false,
      idField: 'id',
      textField: 'band',
      disabledField: 'disabled',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,

    };
    this.dropdownSettingsForAsset = {
      singleSelection: true,
      idField: 'assetId',
      textField: 'asset',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,

    };
    this.dropdownSettingsForEmployee = {
      singleSelection: false, // or true if only one selection is allowed
      idField: 'userId',      // Key for unique IDs
      textField: 'employeName', // Key for displayed text
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 1,
      disabledField: 'disabled', // Field to determine if the option is disabled
      allowSearchFilter: true, // Enable search functionality
    };

  }


  

  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };

  gridOptions: any = {
    defaultColDef: {
      resizable: true,    // ✅ columns resize ho sakte hain
      sortable: true,  // ✅ sorting enable
      filter: true,  // ✅ filtering enable
      floatingFilter: true, // ✅ filters ki input box top me
      minWidth: 80,
      // ✅ rowIndex ke base pe alternate row styling (zebra effect)
      cellClass: (p: any) =>
        p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd'
    },
    context: { componentParent: this },  // ✅ agar component method call karna ho renderer/formatter se
    rowSelection: 'single',     // ✅ single row select
    singleClickEdit: true,       // ✅ click = edit (Pending wale case me helpful)
    stopEditingWhenCellsLoseFocus: true,    // ✅ focus lose hote hi editing stop
    // ✅ jab bhi cell update hoga, ye call hoga
    // onCellValueChanged: (event: any) => this.onCellValueChanged(event)
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  onCellValueChanged(event: any) {
    console.log("--------calue--", event.colDef.field)
     
  }
 

  // ✅ Finance Comment update
  onFinanceCommentChanged(event: any) {
    const rowData = event.data || event;
    const newValue = event.newValue;
    console.log(rowData);

    if (rowData.financeComment == null) {
      return;
    }

    let formData = {
      "financeComment": rowData.financeComment,
      "approvedStatus": rowData?.financeStatus || 'PENDING',
      "assignedAmount": rowData.assignedAmount,
      "financeId": parseInt(this.loggedInUserId)
    }

    this.httpService.callPutService(`${this.config.reimbursementsUpdateFinance}/${rowData.reimbursementApplicationId}`, formData)
      .subscribe((result) => {
        if (result) {
          this.toastr.success('Reimbursement Application  data updated by Finance Successfully', 'success');
        }
      });

  }
 


  
  onActualAmountChangedDetail(rowData: any) {
    if (!rowData.assignedAmount || rowData.assignedAmount <= 0) {
      this.toastr.warning('Actual Amount By Finance is required', 'Warning');
      return;
    }

    if (rowData.financeStatus === 'APPROVED' || rowData.financeStatus === 'REJECTED') {
      return; // prevent accidental update
    }

    const formData = {
      assignedAmount: rowData.assignedAmount,
      financeId: parseInt(this.loggedInUserId, 10),
      approvedStatus: rowData?.financeStatus || 'PENDING'
    };

    this.httpService.callPutService(
      `${this.config.reimbursementsUpdateFinance}/${rowData.reimbursementApplicationId}`,
      formData
    ).subscribe(result => {
      if (result) {
        this.toastr.success('Actual Amount updated successfully', 'Success');
      }
    });
  }

 
 




  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    console.log(params)
  }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');

  }
  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'Expense_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'ExpenseData',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'ExpenseTable'
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['date', 'dateOfExpense']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }


  approvalRenderer(params: any) {
    if (!params.value) return '';
    const status = params.value.toUpperCase();

    let color = '';
    if (status === 'APPROVED') {
      color = '#4caf50'; // green
    } else if (status === 'REJECTED') {
      color = '#f44336'; // red
    } else if (status === 'PENDING') {
      color = '#ff9800'; // orange
    }

    return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }
 



  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'APPROVED_BY_HR_ADMIN_SENT_TO_FINANCE':'#126d79',
      'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN':'#3939ece8',
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800', // orange
      'REJECTED_BY_HR_ADMIN':'#f44336'
    };

    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
        Object.keys(statusColors).find(key => valueUpper.includes(key))!
        ]
        : '#999';

    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {

    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  


  //Employe Login 
  onRowClicked(event: any) {
    this.isDetailsOpen = false;
    console.log('Clicked Column:**', event.colDef);
    this.selectedRow = event.data;
    // if (event.colDef?.field === 'action') {
    //   this.isDetailsOpen = false;
    // } else {
    //   this.isDetailsOpen = true;
    // }
  }
  onCelledClicked(event: any) {
    
    this.selectedRow = event.data;
    this.cdRef.detectChanges()
  }
 
 
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;


  resetGrid() {
    this.isClicked = true; // Trigger animation

    if (this.gridApi) {
      

      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }


  // --------------------------------AG GRID CODE---------------------------------------------------------



  columnDefs: ColDef[] = [];
  

    // ✅ Convert your HTML table structure into AG-Grid column definitions
  buildColumnDefs() {
    this.columnDefs = [
      { headerName: 'Asset', field: 'assetName', minWidth: 150 },
      { headerName: 'Employee Name', field: 'employeeName', minWidth: 190 },
      { headerName: 'Band', field: 'band', minWidth: 120 },
      { headerName: 'Allocating Dept', field: 'authorityDepartment', minWidth: 190 },
      { headerName: 'Authority Name', field: 'allocatingAuthorityName', minWidth: 180 },
      {
        headerName: 'Date Of Allocation',
        field: 'dateOfAllocation',
        hide: this.oprationMethod !== 'Update',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 200,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      } , 
      {
        headerName: 'Current Asset Description',
        field: 'currentAssetDescription',
        editable: true,
        cellEditor: 'agLargeTextCellEditor',
        cellEditorParams: { maxLength: 255, rows: 3, cols: 30 },
        minWidth: 290,
        cellStyle: params => {
          if (!params.value) {
            return { backgroundColor: '#f5edee5e', fontWeight: '600' }; // red tint if empty
          }
          return { backgroundColor: '#f5edee5e', fontWeight: '600' }; // yellow highlight otherwise
        }
      } ,
      {
        headerName: 'Employee Status',
        field: 'employeeAssetStatus',
        hide: this.oprationMethod !== 'Update',
        minWidth: 190
      },
      {
        headerName: 'Employee Comment',
        field: 'employeeComment',
        hide: this.oprationMethod !== 'Update',
        cellEditor: 'agLargeTextCellEditor',
        editable: false,
        minWidth: 220
      },
      {
        headerName: 'Employee Comment Date',
        field: 'employeeCommentDate',
        hide: this.oprationMethod !== 'Update',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 240,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      } ,
      {
        headerName: 'HR ADMIN/ Allocating Authority Comment',
        field: 'authorityDepartmentComment',
        editable: true,
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: { values: this.assetOptions },
        valueFormatter: params => this.formatedataVariable(params.value),
        minWidth: 350,
        cellStyle: {
          backgroundColor: '#e8f5e9',
          fontWeight: '600',
          color: '#0a0a0aff'
        },
        headerTooltip: 'HR ADMIN / Allocating Authority Comment', // optional hover text
        wrapHeaderText: true,
        autoHeaderHeight: true
      },
      {
        headerName: 'Authority Comment Date',
        field: 'authorityCommentDate',
        hide: this.oprationMethod !== 'Update',
        cellRenderer: (params: any) => this.dateRenderer(params),
        comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
        filter: 'agDateColumnFilter',
        minWidth: 240,
        filterParams: {
          filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
          suppressAndOrCondition: true,  // ✅ AND/OR hide
          maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
        }
      }  
    ];
  }

















  selectedAsset: any;

  isDropdownDisabled(): boolean {
    return this.dropDownForEmployee.every(emp => emp.enableCheckAll);

  }



  selectedEmployee: any;
  selectedSubAsset: any;

  filteredEmployees: any[] = [];
  filteredAssets: any[] = [];
  selectedBand: any[] = [];
  // selectedAssets:any;
  getupdateBandData: any = [];
  //   // This function will be triggered when the asset (band) changes
  onAssetChange(event: any) {
    this.selectedBand = [];
    this.selectedAsset = event;
    console.log(event);

    this.httpService.callGetService(`${this.config.bandList}/${event}`)
      .subscribe((elm: any) => {
        // this.dropDownForband = elm.data;
        // if (this.updateData != null) {

        //   this.selectedBand = this.updateData.users.map((elm: any) => 
        //     elm.band,

        // );
        //   this.getAllEmployeeRecord();




        // }
        if (this.updateData != null) {
          console.log('Inside if block');
          this.getupdateBandData = this.updateData.users.map((elm: any) => elm.band);

          this.dropDownForband = elm.data.map((band: any, index: any) => ({
            id: index,
            band: band,
            disabled: this.getupdateBandData.includes(band),
          }));

          this.selectedBand = this.updateData.users.map((elm: any, index: any) => ({
            id: index,
            band: elm.band,
            disabled: this.getupdateBandData.includes(elm.band),
          }));
          this.getAllEmployeeRecord();
        } else {
          console.log('Inside else block');
          this.getupdateBandData = [];
          this.dropDownForEmployee = [];
          this.selectedEmployee = [];
          this.userListDataForAsset = [];
          console.log(this.getupdateBandData);

          if (this.getupdateBandData.length == 0) {
            this.dropDownForband = elm.data.map((band: any, index: any) => ({
              id: index,
              band: band,
              disabled: false, // Always enabled
            }));
          }
          // this.getAllEmployeeRecord();
        }


      })
  }

  //   // This function will be triggered when an employee is selected


  onBandChange(event: any) {
    console.log('Selected Bands:', this.selectedBand); // Log the selected values (array of bands)
    this.selectedBand = event.value;  // Store the selected bands in the array



  }


  onEmployeeChange() {
    console.log(this.selectedBand);

    this.userListDataForAsset.users = this.userListDataForAsset.users.filter((elm: any) => this.selectedBand.includes(elm.band))
    console.log(this.userListDataForAsset);



  }
  selectedAssets: any[] = [];

  allAssets: string[] = []; // Holds all asset names to handle "Select All"


  onSelectSingleSelectFilter: any;
  // // Event Handlers
  onSelectSingleSelectFilterReport(event: any) {

    this.onSelectSingleSelectFilter = event.band;
    this.deselectBand = false;
    console.log(this.onSelectSingleSelectFilter);

    this.getAllEmployeeRecord();
    this.groupEmployees(); // Ensure groupEmployees uses selectedAssets properly


    if (this.selectedEmployee != null) {
      this.allocateEmployees();
    }
    console.log(this.selectedEmployee);



  }

  deselectBand: boolean = false;
  onSelectSingleDelectFilterReport(event: any) {
    this.onSelectSingleSelectFilter = event.band;
    this.deselectBand = true;
    this.getAllEmployeeRecord();
    this.groupEmployees();

    if (this.selectedEmployee != null) {
      this.allocateEmployees();
    }
    console.log(this.selectedEmployee);
  }



  selectAllBand(event: any) {
    console.log('All items selected:', event);
    this.selectedBand = [...event]; // Assign all selected items to selectedAssets
    this.getAllEmployeeRecord();
    this.groupEmployees();

  }

  selectAllEmp(event: any) {
    console.log('All items selected:', event);
    this.selectedEmployee = [...event]; // Assign all selected items to selectedAssets
    console.log(this.selectedEmployee);

    this.groupEmployees();

    this.allocateEmployees();

  }



  
  onDeSelectAllEmpForReport(event: any) {
    console.log('All items deselected:', event);
    this.selectedEmployee = []; // Clear selectedAssets

    this.groupEmployees();
  }
  onDeSelectAllEmpFor(event: any) {
    console.log('Deselect All Event:', event);

    if (!event || (Array.isArray(event) && event.length === 0)) {
      // Clear all selected employees when deselect all is triggered
      this.selectedEmployee = [];
      console.log('All items deselected');
    } else {
      // Check if the userId already exists in the selectedEmployee array
      const isUserIdPresent = this.selectedEmployee.some(
        (user: any) => user.userId == event.userId
      );

      if (isUserIdPresent) {
        // If the userId does not exist, push the event to the array
        this.selectedEmployee.push(event);
       
        
        this.allocateEmployees();
      } else {
        // Remove the record matching the userId
        this.selectedEmployee = this.selectedEmployee.filter(
          (user: any) => user.userId !== event.userId
        );
        this.deleteByEmployee(event)
        console.log('Item deselected:', event);
      }

    }


    console.log('Updated Selected Employees:', this.selectedEmployee);

    this.groupEmployees(); // Perform additional logic if necessary
  }
  deleteByEmployee(event: any) {

    let findUserId: any = [];
    findUserId.push(event.userId);


    let findAssetId = this.userListDataForAsset.users.filter((elm: any) => findUserId.includes(elm.userId));
    let id = findAssetId.map((elm: any) => elm.id)
    this.httpService.callDeleteService(`${this.config.deleteAssetFromEmployee}/${id[0]}`)
      .subscribe((elm: any) => {
        console.log(elm);
        if (elm) {
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: elm.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
        }
        this.assetAllocationData();
      })
  }

  onDeSelectAllBand(event: any) {
    console.log('All items deselected:', event);

    this.selectedBand = [];
    this.selectedEmployee = [];
    this.groupEmployees();
  }
  nedisableempBandArray: any = [];
  disableEmployeeSelection(): any {
    console.log(this.updateData.users);

    // Assuming that selectedEmployee is an array of selected employee objects
    if (this.updateData.users != 0) {
      this.selectedEmployee = this.updateData.users.map((elm: any) => ({
        userId: elm.userId,           // Matches 'idField' for the dropdown
        employeName: elm.employeeName // Matches 'textField' for display
      }));
    }
  }
  disabledata: any = [];

  getAllEmployeeRecord() {
    console.log("getAllEmployeeRecord");
    console.log(this.onSelectSingleSelectFilter);

    const band = this.selectedBand.map((elm: any) => elm.band);
    const today = new Date().toISOString().split('T')[0];
    const year = this.year.split('-')[0];

    const formData = {
      companyId: this.loggedInUserCompanyID,
      bands: band,
      from: today,
      to: today,
      fromYear: year,
      toYear: year,
    };

    this.httpService.callPostService(`${this.config.getAllEmployeeListAgainstBand}`, formData)
      .subscribe((elm: any) => {


        if (elm.data && this.updateData == null && !this.deselectBand) {
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: elm.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe((result) => {

          });

        }
        this.dropDownForEmployee = elm.data.map((user: any) => ({
          userId: user.id,
          employeName: user.firstName + user.lastName,
          userBand: user.band,
          enableCheckAll: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          allowSearchFilter: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          disabled: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : false,
        }));

        console.log(this.dropDownForEmployee);

        this.selectedEmployee = elm.data.map((user: any) => ({
          userId: user.id,
          employeName: user.firstName + user.lastName,
          enableCheckAll: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          allowSearchFilter: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : true,
          disabled: this.updateData
            ? this.onSelectSingleSelectFilter === user.band
              ? false
              : true
            : false,
        }));

        let emptyEmployeeArray: any[] = [];
        console.log("Initial Empty Array:", emptyEmployeeArray);

        if (this.updateData != null) {
          emptyEmployeeArray = this.selectedEmployee || [];
          console.log("Temp Employee Array:", emptyEmployeeArray);

          if (emptyEmployeeArray.length > 0) {
            this.selectedEmployee = emptyEmployeeArray;
          } else {
            this.selectedEmployee = this.updateData.users.map((elm: any) => ({
              userId: elm.userId,
              employeName: elm.employeeName,
              enableCheckAll: this.onSelectSingleSelectFilter === elm.band ? false : true,
              allowSearchFilter: this.onSelectSingleSelectFilter === elm.band ? false : true,
              disabled: this.onSelectSingleSelectFilter === elm.band ? false : true,
            }));
          }

          this.disabledata = this.dropDownForEmployee.every(emp => emp.enableCheckAll);
          console.log(this.disabledata);
        }

        this.allocateEmployees();
      });
  }

  onAssetClick() {
    console.log('Assets dropdown clicked');
    // You can handle other logic when dropdown is clicked, if needed
  }

  allocateEmployees() {

    const assetnameData = this.originalAssets.filter((elm: any) => elm.assetId == this.selectedAsset);
    const notMatchID = assetnameData.map((elm: any) => elm.userId);
    const data = this.selectedEmployee.filter((elm: any) => !notMatchID.includes(elm.userId));
    const employeeID = data.map((elm: any) => elm.userId);
    // let userId:any=[]
    // employeeID.filter((elm: any) => {
    //   if (!userId.some((e: any) => e === elm)) {
    //     userId.push(elm);
    //   }
    // });
    
    let userId: any[] = [];

    employeeID.filter((elm: any) => {
      if (elm != null && elm !== undefined && !userId.some((e: any) => e === elm)) {
        userId.push(elm);
      }
    });
    
    const formData = {

      "companyId": this.loggedInUserCompanyID,
      "assetAuthorityId": null,
      "assetId": this.selectedAsset,
      "employeeIds": userId,
      "dateOfAllocation": null,
      "currentAssetDescription": ''
    }

    this.httpService.callPostService(`${this.config.allocateEmployee}`, formData)
      .subscribe((elm: any) => {
        this.assetAllocationData();

      })
  }




  assetManagementHeader = [
    { label: 'Asset', isMandatory: true, sortingName: 'asset' },
    { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
    { label: 'Band', isMandatory: true, sortingName: 'band' },
    { label: 'Allocating Dept', isMandatory: true, sortingName: 'allocatingAuthorityDept' },
    { label: 'Authority Name', isMandatory: true, sortingName: 'allocatingAuthorityName' },
    { label: 'Date Of Allocation', isMandatory: true, sortingName: 'reimbursementType' },
    { label: 'Current Asset Description', isMandatory: true, sortingName: 'currentAssetDescription' },
    { label: 'HR ADMIN/Allocating Authority Comment', isMandatory: true, sortingName: 'reimbursementLimit' },
    { label: 'Authority Comment Date', isMandatory: true, sortingName: 'actualAmount' },


  ];





  AllAssetListingData: any[] = [];
  getAllaseetListingData() {
    this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((elm: any) => {
        this.AllAssetListingData = elm.data;
        console.log(elm);


      })

  }
  originalAssets: any[] = [];
  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((elm: any) => {
        console.log(elm);

        this.originalAssets = elm.data;
        console.log("8888.............................",  this.originalAssets);
        
        // this.groupAssetsByName();
        this.groupEmployees();
      })

  }
  assets: any = [];
  allUsers: any[] = [];

  // Group assets by asset name and merge users
  groupAssetsByName() {
    console.log(this.originalAssets);

    // Create a map to hold the grouped assets
    const assetMap = new Map<string, any>();

    // Loop through the original assets and group by asset name
    for (const asset of this.originalAssets) {
      if (assetMap.has(asset.assetName)) {
        // If asset name already exists, merge the users
        const existingAsset = assetMap.get(asset.assetName);
        existingAsset.users.push({
          employeeName: asset.employeeName,
          employeeComment: asset.employeeComment,
          allocatingAuthorityName: asset.allocatingAuthorityName,
          allocatingAuthorityDept: asset.allocatingAuthorityDept
        });
      } else {
        // If asset name doesn't exist, add it to the map
        assetMap.set(asset.assetName, {
          assetName: asset.assetName,
          band: asset.band,
          dateOfAllocation: asset.dateOfAllocation,
          isExpand: false,
          users: [{
            employeeName: asset.employeeName,
            userId: asset.userId,
            employeeComment: asset.employeeComment,
            allocatingAuthorityName: asset.allocatingAuthorityName,
            allocatingAuthorityDept: asset.allocatingAuthorityDept
          }]
        });


      }
    }

    // Convert the map to an array
    this.assets = Array.from(assetMap.values());
    console.log(this.updateData);
  }
 




  dropDownForband: any[] = [];
  dropDownForEmployee: any[] = [];
  finalTableListData: any[] = [];
   
  groupEmployees() {
    // Initialize an empty array to hold all users
    this.allUsers = [];
  console.log("999999...............", this.originalAssets);
  
    // Loop through the original assets and collect all user details
    for (const asset of this.originalAssets) {
      this.allUsers.push({
        id: asset.id,
        employeeName: asset.employeeName,
        employeeComment: asset.employeeComment,
        employeeAssetStatus: asset.employeeAssetStatus,
        allocatingAuthorityName: asset.authorityName,
        authorityDepartment: asset.authorityDepartment,
        employeeEmail: asset.employeeEmail,
        authorityEmail: asset.authorityEmail,
        assetName: asset.assetName,
        band: asset.band,
        userId: asset.userId,
        assetId: asset.assetId,
        dateOfAllocation: asset.dateOfAllocation,
        currentAssetDescription: asset.currentAssetDescription,
        authorityCommentDate: asset.authorityCommentDate,
        authorityDepartmentComment: asset.authorityDepartmentComment
      });
     
      
    }

console.log("11111111111111111---", this.allUsers);

    
  
    const specificAsset = this.assets.map((asset: any) => {
      return {
        assetName: asset.assetName,
        band: asset.band,
      };
    });
  
    const list = {
      assetData: specificAsset,
      users: this.allUsers
    };
  
    if (this.updateData != null) {
      if (this.oprationMethod === "Update") {
        const insertIndex = this.assetManagementHeader.findIndex(
          (item) => item.sortingName === "currentAssetDescription"
        );
  
        if (insertIndex !== -1) {
          const alreadyAdded = this.assetManagementHeader.some(
            (item) => item.sortingName === "employeeAssetStatus"
          );
  
          if (!alreadyAdded) {
            this.assetManagementHeader.splice(insertIndex + 1, 0,
              { label: 'Employee Status', isMandatory: true, sortingName: 'employeeAssetStatus' },
              { label: 'Employee Comment', isMandatory: true, sortingName: 'employeeComment' },
              { label: 'Employee Comment Date', isMandatory: true, sortingName: 'employeeCommentDate' }
            );
          }
        }
      }
  
      //  FIX: Convert date strings to Date objects here
      this.userListDataForAsset = {
        ...this.updateData,
        users: this.updateData?.users?.map((user: any) => ({
          ...user,
          authorityDepartmentComment: this.normalizeAssetComment(user.authorityDepartmentComment),
          dateOfAllocation:user.dateOfAllocation,
          authorityCommentDate:user.authorityCommentDate,
          employeeCommentDate:user.employeeCommentDate
        }))
      };
  
      console.log("222222222--", this.userListDataForAsset);
      
      this.dropdownDataForAsset = this.userListDataForAsset?.users?.map((user: any, index: number) => ({
        assetId: user.assetId,
        asset: user.assetName,
        employeeName: user.employeeName,
        userId: user.userId
      }));
  
      const selectedEmployees = this.selectedEmployee?.map((elm: any) => elm?.userId);
      let updatetimeselectAnotherEmployee = list?.users?.filter((elm: any) => selectedEmployees?.includes(elm.userId));
      updatetimeselectAnotherEmployee = updatetimeselectAnotherEmployee.filter((elm: any) => elm.assetId == this.selectedAsset);
  
      if (updatetimeselectAnotherEmployee.length > 0) {
        this.userListDataForAsset = {
          users: updatetimeselectAnotherEmployee.map((record: any) => ({
            ...record,
            dateOfAllocation:record.dateOfAllocation,
            authorityCommentDate:record.authorityCommentDate,
            employeeCommentDate:record.employeeCommentDate,
       
          }))
          
        };
        console.log("555555555555555555555",  this.userListDataForAsset);
        
      }
  
    } else {
      this.userListDataForAsset = list;
  
      const selectedEmployees = this.selectedEmployee?.map((elm: any) => elm?.userId);
      this.finalTableListData = this.userListDataForAsset?.users?.filter((elm: any) => selectedEmployees?.includes(elm.userId));
      console.log(" Final finalTableListData:", this.finalTableListData);
      this.userListDataForAsset.users = this.finalTableListData.map((record: any) => ({
        ...record,
        dateOfAllocation: record.dateOfAllocation ? record.dateOfAllocation : this.datedisplay,
        authorityCommentDate: record.authorityCommentDate ? record.authorityCommentDate : this.datedisplay,
        employeeCommentDate: record.employeeCommentDate ? record.employeeCommentDate : this.datedisplay
      })).filter((elm: any) => elm.assetId == this.selectedAsset);
      console.log(" UserListDta----------:", this.userListDataForAsset?.users);
    }
  
    console.log(" Final userListDataForAsset:", this.userListDataForAsset?.users);
  }
  
  normalizeAssetComment(comment: string): string {
    return comment
      ?.trim()
      ?.toUpperCase()
      ?.replace(/\s+/g, '_') || '';
  }
  



  parseToDate(dateStr: any): Date | null {
    if (!dateStr || typeof dateStr !== 'string') return null;
    const parts = dateStr.split('-');
    if (parts.length !== 3) return null;
    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const year = parseInt(parts[2], 10);
    const result = new Date(year, month, day);
    return isNaN(result.getTime()) ? null : result;
  }
  

  updatedAssetData: Asset[] = [];

  // -----------------------------------------------updated data from the user list------------------------------------------
  // updateAssetData(index: number) {
  //   // Gather the updated data from the user list
  //   const updatedUser = this.userListDataForAsset.users[index];
  //   console.log("0000000000.........",updatedUser);
    
  //   //-------------------------------------- authorityCommentDate----------------------------------------------
  //   let selectedDate = new Date(updatedUser.authorityCommentDate);  // Set the date at midnight
  //   let localDate = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000);
  //   const authorityCommentDate = localDate.toISOString();

  //   //-----------------------------------------dateOfAllocation---------------------------------------

  //   let selecteddateOfAllocation = new Date(updatedUser.dateOfAllocation);  // Set the date at midnight
  //   let date = new Date(selecteddateOfAllocation.getTime() - selecteddateOfAllocation.getTimezoneOffset() * 60000);
  //   const dateOfAllocation = date.toISOString();


  //   const existingIndex = this.updatedAssetData.findIndex(
  //     data => data.assetName === updatedUser.assetName && data.id === updatedUser.id
  //   );

  //   if (existingIndex === -1) {
  //     // If not found, add a new object with updated data
  //     this.updatedAssetData.push({
  //       id: updatedUser.id,
  //       assetName: updatedUser.assetName,
  //       currentAssetDescription: updatedUser.currentAssetDescription,
  //       authorityDepartmentComment: updatedUser.authorityDepartmentComment,
  //       authorityCommentDate: authorityCommentDate,
  //       dateOfAllocation: dateOfAllocation
  //     });
  //   } else {
  //     // If found, update the existing object
  //     this.updatedAssetData[existingIndex] = {
  //       id: updatedUser.id,
  //       assetName: updatedUser.assetName,
  //       currentAssetDescription: updatedUser.currentAssetDescription,
  //       authorityDepartmentComment: updatedUser.authorityDepartmentComment,
  //       authorityCommentDate: authorityCommentDate,
  //       dateOfAllocation: dateOfAllocation
  //     };
  //   }

  // }

  updateAssetData(index: number) {
    // Gather the updated data from the user list
    const updatedUser = this.userListDataForAsset.users[index];
    console.log("0000000000.........", this.userListDataForAsset);
  
    // -------------------------------------- authorityCommentDate ----------------------------------------------
    let selectedDate = new Date(updatedUser.authorityCommentDate);
    let localDate = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000);
    const authorityCommentDate = localDate.toISOString();
  
    // -------------------------------------- dateOfAllocation ----------------------------------------------
    let selecteddateOfAllocation = new Date(updatedUser.dateOfAllocation);
    let date = new Date(selecteddateOfAllocation.getTime() - selecteddateOfAllocation.getTimezoneOffset() * 60000);
    const dateOfAllocation = date.toISOString();
  
    const updatedData = {
      id: updatedUser.id,
      assetName: updatedUser.assetName,
      currentAssetDescription: updatedUser.currentAssetDescription,
      authorityDepartmentComment: updatedUser?.authorityDepartmentComment,
      authorityCommentDate: authorityCommentDate,
      dateOfAllocation: dateOfAllocation,
  
      //  ADDITIONAL required fields from backend
      userId: updatedUser.userId,
      band: updatedUser.band,
      authorityName: updatedUser.authorityName,
      assetStatus: updatedUser.assetStatus,
      employeeAssetStatus: updatedUser.employeeAssetStatus,
      employeeName: updatedUser.employeeName,
      companyId: updatedUser.companyId
      //  Add more if your backend expects others
    };
    console.log("3333.........",updatedData);
    
  
    const existingIndex = this.updatedAssetData.findIndex(
      data => data.assetName === updatedUser.assetName && data.id === updatedUser.id
    );
  
    if (existingIndex === -1) {
      this.updatedAssetData.push(updatedData);
    } else {
      this.updatedAssetData[existingIndex] = updatedData;
    }
  
    console.log('Final Updated Asset Data:', this.updatedAssetData);
  }
  

  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 255 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000); // Reset after 3s so it can show again next time
    }
  }



  updateDataByHr() {
    console.log("Updated Data to be sent:", this.userListDataForAsset);
    // Check if there is anything to update
  if (this.userListDataForAsset?.users?.length === 0) {
    console.warn("No updated data to send.");
    return;
  }
  //  currentAssetDescription is exactly 255 characters
  const has255CharDescription = this.userListDataForAsset?.users?.some(
    (item: any) => item.currentAssetDescription?.length > 255
  );

  if (has255CharDescription) {
    return;
  }
  console.log('Sending updated asset data:', this.updatedAssetData);


    this.userListDataForAsset?.users?.forEach((element: any) => {
      this.httpService.callPutService(`${this.config.updateByHR}`, element).subscribe((result: any) => {
        console.log(result);
        //  this.assetAllocationData();
        //  this.dialogRef.close();
        if (result) {

          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: result.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });

          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe((result) => {

            this.dialogRef.close();
          });
        }

      })
    })

  }



  cancelData() {
    this.dialogRef.close();
  }
}

interface Asset {
  assetName: string;
  id: any

  currentAssetDescription: string;
  authorityDepartmentComment: string;
  dateOfAllocation: string,
  authorityCommentDate: string;  // Changed from dateOfAllocation to authorityCommentDate
}
